import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus-circle_08411",
  "use": "plus-circle_08411-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"plus-circle_08411\">\n    <use xlink:href=\"#plus-circle_08411_path0_fill\" />\n    <defs>\n        <path id=\"plus-circle_08411_path0_fill\" d=\"M8.8 4.8H7.2v2.4H4.8v1.6h2.4v2.4h1.6V8.8h2.4V7.2H8.8V4.8zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.4c-3.52 0-6.4-2.88-6.4-6.4 0-3.52 2.88-6.4 6.4-6.4 3.52 0 6.4 2.88 6.4 6.4 0 3.52-2.88 6.4-6.4 6.4z\" />\n    </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol